<template>
  <label
    class="def-input-password"
    :class="{
      'def-input-password_invalid': !isValid || isError,
      'def-input-password_success': isSuccess,
    }"
  >
    <span
      class="def-input-password__placeholder"
      :class="{ 'def-input-password__placeholder_center': !saveValue && !isFocus }"
    >
      {{ placeholder }}
    </span>

    <input
      :id="id"
      :type="isShowPassword ? 'text' : 'password'"
      :name="name"
      :required="required"
      :value="saveValue"
      :autocomplete="autocomplete"
      :form="form"
      :readonly="readonly"
      :pattern="pattern"
      class="def-input-password__input"
      @input="handlerInput"
      @click="$emit('click', $event)"
      @keypress="$emit('keypress', $event)"
      @keydown="$emit('keydown', $event)"
      @keyup="$emit('keyup', $event)"
      @invalid.prevent="handlerInvalid"
      @blur="handlerBlur"
      @focus="handlerFocus"
    />
    <span class="def-password-btn" @click="isShowPassword = !isShowPassword">
      <svg viewBox="0 0 20 20" class="def-password-btn__icon">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.71866 9.78552C1.73625 9.7294 3.65751 4.18756 10.0503 4.18756C16.443 4.18756 18.3643 9.7294 18.3827 9.78552L18.4707 10.0502L18.3819 10.3148C18.3643 10.3709 16.443 15.9128 10.0503 15.9128C3.65751 15.9128 1.73625 10.3709 1.71782 10.3148L1.62988 10.0502L1.71866 9.78552ZM3.41212 10.0502C3.83255 11.0167 5.56872 14.2377 10.0503 14.2377C14.5293 14.2377 16.2663 11.02 16.6884 10.0502C16.268 9.08368 14.5318 5.86259 10.0503 5.86259C5.57123 5.86259 3.83422 9.08033 3.41212 10.0502ZM10.0503 8.37514C10.0503 9.29222 10.8082 10.0502 11.7253 10.0502C12.0218 10.0502 12.2973 9.96391 12.5402 9.82572C12.5425 9.85543 12.5465 9.88462 12.5505 9.9138C12.5567 9.95865 12.5628 10.0035 12.5628 10.0502C12.5628 11.4254 11.4246 12.5627 10.0503 12.5627C8.67506 12.5627 7.53772 11.4254 7.53772 10.0502C7.54211 9.38516 7.80823 8.74863 8.27848 8.27838C8.74872 7.80814 9.38525 7.54201 10.0503 7.53762C10.0969 7.53762 10.1418 7.54377 10.1866 7.54992C10.2158 7.55392 10.245 7.55793 10.2747 7.56024C10.1365 7.80312 10.0503 8.07866 10.0503 8.37514Z"
          fill="#030304"
        />
      </svg>
    </span>
    <transition name="fade">
      <span v-if="!isValid || isShowError" class="def-input-password__error">
        <slot />
      </span>
    </transition>
  </label>
</template>

<script>
export default {
  name: 'DefInputPassword',
  props: {
    name: String,
    placeholder: String,
    required: Boolean,
    autocomplete: Boolean,
    value: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '',
    },
    id: String,
    form: String,
    isShowError: {
      type: Boolean,
      default: false,
    },
    isSuccess: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    pattern: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {
      isValid: true,
      isFocus: false,
      saveValue: this.value,
      isShowPassword: false,
    };
  },
  watch: {
    value(newValue) {
      this.saveValue = newValue;
    },
    modelValue(newValue) {
      this.saveValue = newValue;
    },
  },
  mounted() {},
  methods: {
    handlerInput(e) {
      this.saveValue = e.target.value;
      this.$emit('update:modelValue', this.saveValue);
    },
    handlerInvalid(e) {
      if (this.required) {
        this.isValid = false;
      }

      this.$emit('invalid', e);
    },
    handlerBlur(e) {
      const { target } = e;
      if (target.checkValidity() && this.required) {
        this.isValid = true;
      }
      this.isFocus = false;
      this.$emit('blur', e);
    },
    handlerFocus(e) {
      this.isFocus = true;
      this.$emit('focus', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.def-input-password {
  display: flex;
  align-items: flex-end;
  position: relative;
  height: 52px;
  padding: 8px 16px;
  border: 1px solid #c8c8c8;
  &__placeholder {
    position: absolute;
    top: 8px;
    color: var(--color-dark-grey);
    transition: 0.2s linear top;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
    font-size: 14px;
    font-weight: 500;
    &_center {
      font-size: rem(16);
      top: 16px;
    }
  }
  &__input {
    font-weight: 500;
    font-size: rem(16);
    border: none;
    height: 20px;
    transition: 0.2s linear border-bottom-color;
    padding: 0;
    width: 100%;
  }
  &__error {
    position: absolute;
    left: 16px;
    top: calc(100% + 4px);
    font-size: rem(10);
    line-height: 100%;
    color: var(--color-red);
  }
  &_invalid {
    border-color: var(--background-red);
  }
  &_success {
    border-color: var(--background-green);
  }
  //&__icon-error {
  //  position: absolute;
  //  top: 13px;
  //  right: 0;
  //  fill: var(--background-red);
  //  width: 16px;
  //  height: 16px;
  //}
  //&__icon-success {
  //  position: absolute;
  //  top: 13px;
  //  right: 0;
  //  width: 16px;
  //  height: 16px;
  //}
}
.def-password-btn {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  &__icon {
    width: 20px;
    height: 20px;
  }
}
</style>
